import { PropTypes } from "base/react-libs";
import { useState } from "react";
import NavButton from "components/lists/nav-button";
import JourneysNavButtonContent from "./journeys-nav-button-content";
import JourneyGroupSelector from "./journey-group-selector";

// THIS WILL BE DEPRECATED SOON
const JourneysTitleList = ({ journeys, journeyGroups, selectedJourneyGroup, setSelectedJourneyGroup }) => {
  const [selectedJourney, setSelectedJourney] = useState({});

  return (
    <div className="journeys-title-list">
      <JourneyGroupSelector
        journeyGroups={journeyGroups}
        setSelectedJourneyGroup={setSelectedJourneyGroup}
        selectedJourneyGroup={selectedJourneyGroup}
      />
      {journeys &&
        journeys.length > 0 &&
        journeys.map((journey) => {
          const {
            id,
            name,
            tasks_due_counts: { total },
          } = journey;

          return (
            <NavButton
              key={`title-${name}`}
              active={selectedJourney.id}
              activeWhen={id}
              onSelect={() => setSelectedJourney(journey)}
              buttonProps={{ type: "secondary", href: `/cadences/${id}` }}
            >
              <JourneysNavButtonContent name={name} tasksDueCount={total} />
            </NavButton>
          );
        })}
    </div>
  );
};

JourneysTitleList.propTypes = {
  journeyGroups: PropTypes.array,
  setSelectedJourneyGroup: PropTypes.func,
  selectedJourneyGroup: PropTypes.object,
  journeys: PropTypes.array,
};

export default JourneysTitleList;
